(function () {
  function allowedOrigin(origin) {
    if (!origin) return false;
    try {
      var u = new URL(origin);
      if (u.protocol !== "https:") return false;
      var host = u.hostname;
      return host === "static.aerobis.com" || host.endsWith(".static.aerobis.com");
    } catch (err) {
      return false;
    }
  }

  window.addEventListener("message", function (e) {
    if (!allowedOrigin(e.origin)) return;
    var data = e.data;
    if (!data || typeof data !== "object") return;
    var name = data.aerobisEmbed;
    if (!name) return;
    if (data.height == null || data.height === "") return;
    var iframe = document.getElementById("aerobis-" + String(name));
    if (!iframe) return;
    var h = Math.round(Number(data.height));
    if (!isFinite(h)) return;
    if (h < 120) h = 120;
    if (h > 2000) h = 2000;
    iframe.style.height = h + "px";
  });
})();
